import type { Messages } from '../en'

export const login: Messages['login'] = {
  title: 'Entrar',
  subtitle: 'Smith Factory',
  identifyLead: 'Informe seu e-mail corporativo — nós levamos você pelo caminho certo.',
  workEmail: 'E-mail corporativo',
  workEmailPlaceholder: 'voce@empresa.com.br',
  invalidEmail: 'Informe o endereço completo, como voce@empresa.com.br.',
  firstTimeHint: 'Primeiro acesso? Use o endereço para o qual seu convite foi enviado.',
  usePasskey: 'Entrar com chave de acesso',
  noPasskeyHere: 'Sem chave de acesso neste dispositivo? Continue com seu e-mail acima.',
  continueWithOrgSso: 'Continuar com o SSO da sua organização',
  signInWith: (label) => `Entrar com ${label}`,

  welcomeBack: 'Bem-vindo(a) de volta',
  continueAs: 'Continuar',
  rememberedVia: {
    passkey: 'com sua chave de acesso',
    code: 'com um código por e-mail',
    sso: (label) => `pelo ${label}`
  },
  useAnotherAccount: 'Usar outra conta',
  forgetAccount: 'Remover deste dispositivo',
  passkeyFallback: 'Não funcionou? Enviar um código por e-mail',

  redirecting: (label) => `Levando você ao ${label}…`,

  codeTitle: 'Confira seu e-mail',
  codeSentBefore: 'Enviamos um código de 8 dígitos para',
  codeSentAfter: '.',
  codeArrives: 'Ele chega em até um minuto se este endereço tiver acesso ao portal — confira também o spam.',
  verificationCode: 'Código',
  signIn: 'Entrar',
  resend: 'Enviar um novo código',
  resendIn: (seconds) => `Novo código em ${seconds}s`,
  codeResent: 'Um novo código está a caminho. Use o mais recente.',
  useDifferentEmail: 'Usar outro e-mail',
  usePasskeyInstead: 'Usar uma chave de acesso',

  passkeyRequiredTitle: 'Crie uma chave de acesso',
  passkeyRequiredBody: (companies) =>
    `${companies} usa chaves de acesso para entrar. Crie uma neste dispositivo — você confirma com sua digital, rosto ou bloqueio de tela. Sem senha.`,
  passkeyRequiredBodyGeneric:
    'Sua empresa usa chaves de acesso para entrar. Crie uma neste dispositivo — você confirma com sua digital, rosto ou bloqueio de tela. Sem senha.',
  passkeyRecommendedTitle: 'Adicione uma chave de acesso',
  passkeyAdminReason:
    'Você é administrador(a): gerenciar pessoas exige uma chave de acesso — um código por e-mail não basta para isso.',
  passkeyCompaniesReason: (companies) => `Com uma chave de acesso você também entra em ${companies}.`,
  passkeyOptionalTitle: 'Dispense o código da próxima vez',
  passkeyOptionalBody:
    'Crie uma chave de acesso neste dispositivo e entre com sua digital, rosto ou bloqueio de tela — sem esperar código.',
  passkeyHowTo:
    'O navegador vai perguntar onde salvá-la: neste dispositivo, no seu celular ou numa chave de segurança.',
  and: 'e',
  createPasskey: 'Criar chave de acesso',
  useExistingPasskey: 'Usar uma chave de acesso que já tenho',
  notNow: 'Agora não',
  passkeyUnsupported:
    'Este navegador não cria chaves de acesso. Abra o portal num navegador atualizado, ou no seu celular, e entre por lá.',
  passkeyWindowExpired: 'Isso demorou um pouco demais. Entre de novo para criar a chave de acesso.',

  passkeyDismissed: 'A janela da chave de acesso foi fechada. Tente novamente quando estiver pronto(a).',
  passkeyNotRecognized: 'Esta chave de acesso não é reconhecida pelo portal. Continue com seu e-mail para entrar.',
  passkeyGenericError: 'Algo deu errado com a chave de acesso. Tente novamente.',

  oidcAccessDenied: 'O login foi cancelado.',
  oidcNotProvisioned: 'Sua conta ainda não tem acesso ao portal. Peça um convite ao administrador.',
  oidcTenantNotAllowed: 'Sua organização não está habilitada neste portal. Fale com o administrador.',
  oidcRoleNotAssigned:
    'Sua conta não está atribuída a este portal. Peça ao administrador para atribuir você ao aplicativo.',
  oidcEmailMissing: 'Sua conta de login não tem um e-mail verificado. Fale com o administrador.',
  oidcEmailNotAllowed:
    'O e-mail desta conta não é coberto pelo login único (SSO) da sua organização. Fale com o administrador.',
  oidcSsoUnknown: 'Este link de login não é mais válido. Peça o link atual ao administrador.',
  oidcExpired: 'A tentativa de login expirou ou foi adulterada. Tente novamente.',
  oidcDisabled: 'O login único (SSO) não está habilitado.',
  oidcGenericError: 'Falha no login único (SSO). Tente novamente.'
}
